import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import forgetpassword from "../../images/fp-g.svg";
import ScrollToTop from "../ScrollToTop";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!token) {
      setMessage("❌ Invalid or expired link");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("❌ Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        "https://sakhisshop.com/api/customers/reset-password/confirm",
        { token, newPassword },
      );
      setMessage("✅ Password reset successfully!");
      setTimeout(() => navigate("/MyAccountSignIn"), 2000);
    } catch (err) {
      setMessage(err.response?.data?.error || "❌ Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ScrollToTop />
      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            {/* Left side image */}
            <div className="col-12 col-md-6 col-lg-4 order-lg-1 order-2">
              <img src={forgetpassword} alt="reset" className="img-fluid" />
            </div>

            {/* Right side form */}
            <div className="col-12 col-md-6 offset-lg-1 col-lg-4 order-lg-2 order-1 d-flex align-items-center">
              <div>
                <div className="mb-lg-9 mb-5">
                  <h1 className="mb-2 h2 fw-bold">Reset your password</h1>
                  <p>
                    Please enter your new password below. Once updated, you can
                    sign in with your new password.
                  </p>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    {/* New Password */}
                    <div className="col-12">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="New Password"
                        value={newPassword}
                        required
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>

                    {/* Confirm Password */}
                    <div className="col-12">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        required
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>

                    {/* Message */}
                    {message && (
                      <div className="col-12">
                        <p
                          className={
                            message.startsWith("✅")
                              ? "text-success"
                              : "text-danger"
                          }
                        >
                          {message}
                        </p>
                      </div>
                    )}

                    {/* Buttons */}
                    <div className="col-12 d-grid gap-2">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Reset Password"}
                      </button>
                      <Link to="/MyAccountSignIn" className="btn btn-light">
                        Back to Sign In
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
